import React from "react";
import {
  PageBuilderFeaturedContentRowFragment,
  PageBuilderFeaturedContentRowsFragment
} from "types/graphql-types";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import FeaturedContentRows from "components/FeaturedContentRow/FeaturedContentRows";
import { useGeolocation } from "../../utils/localization/geolocation/GeolocationContext";
import { matchesAny } from "../../utils/localization/geolocation";
import FeaturedContentRow, {
  FeautedContentRowImageSizeType
} from "components/FeaturedContentRow/FeaturedContentRow";
import { graphql } from "gatsby";
import PageBuilderButtonCTA from "./PageBuilderButtonCTA";
import { HeadingType } from "@silversea-ssc/ui-components-react";

export type PageBuilderFeaturedContentRowsProps =
  PageBuilderFeaturedContentRowsFragment & {
    headingType: HeadingType;
  };

const PageBuilderFeaturedContentRows: React.FC<
  React.PropsWithChildren<PageBuilderFeaturedContentRowsProps>
> = ({ heading, headingType, rows = [] }) => {
  const geolocation = useGeolocation();
  const filteredRows = rows.filter(
    (item): item is PageBuilderFeaturedContentRowFragment => {
      if (!item) return false;
      return matchesAny(item.locationFilters, geolocation);
    }
  );

  return (
    <React.Fragment>
      <PageBuilderSectionTitle headingType={headingType} {...heading} />
      <FeaturedContentRows>
        {filteredRows.map((service) => {
          const buttons = service.link?.map((b) => (
            <PageBuilderButtonCTA
              key={b?._key}
              {...b}
              defaultButtonVariant="primary"
            />
          ));
          return (
            <FeaturedContentRow
              key={service._key}
              image={service.image}
              imageSize={
                (service.imageSize ||
                  "regular") as FeautedContentRowImageSizeType
              }
              title={service.title?.localized || ""}
              description={service.description?.localized}
              buttons={buttons}
            />
          );
        })}
      </FeaturedContentRows>
    </React.Fragment>
  );
};

export default PageBuilderFeaturedContentRows;

export const fragments = graphql`
  fragment PageBuilderFeaturedContentRow on SanityFeaturedContentRow {
    _key
    title {
      localized
    }

    description {
      localized
    }

    image {
      ...ImageWithAlt
    }

    imageSize

    link {
      ...ButtonCTA
    }

    locationFilters {
      ...AirNonAirOrLocationFilter
    }
  }
  fragment PageBuilderFeaturedContentRows on SanityFeaturedContentRows {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    rows {
      ...PageBuilderFeaturedContentRow
    }
  }
`;
